module.exports = __webpack_public_path__ + "static/media/time.9c52ee34.svg";